// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let TailwindMerge = require("tailwind-merge");
let JsxRuntime = require("react/jsx-runtime");

function MainLayout(props) {
  let flexDirection = props.flexDirection;
  let __noPadding = props.noPadding;
  let noPadding = __noPadding !== undefined ? __noPadding : false;
  let paddingClass = noPadding ? "" : "py-[20px] sm:py-[25px] md:py-[30px] lg:py-[40px]";
  let directionClass;
  if (flexDirection !== undefined) {
    switch (flexDirection) {
      case "column" :
        directionClass = "flex flex-col";
        break;
      case "column-reverse" :
        directionClass = "flex flex-col-reverse";
        break;
      case "row" :
        directionClass = "flex flex-row";
        break;
      case "row-reverse" :
        directionClass = "flex flex-row-reverse";
        break;
      default:
        directionClass = "";
    }
  } else {
    directionClass = "";
  }
  return JsxRuntime.jsx("div", {
    children: props.children,
    className: TailwindMerge.twMerge([
      "grow",
      paddingClass,
      directionClass
    ])
  });
}

let make = MainLayout;

exports.make = make;
/* tailwind-merge Not a pure module */
